<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script lang="ts">
import { Options as Component, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

const user = namespace('user');
UIkit.use(Icons);

@Component({
  name: 'App',
})
class App extends Vue {
  @user.Action('setLoginData') setLoginData: (token: string) => void;
  @user.Action('refreshJWT') refreshJWT: () => Promise<void>;

  @user.State('user') user;

  @user.Getter
  CASLUser;

  async created() {
    this.$i18n.locale = navigator.language?.substring(0, 2);
    //this.$router.replace({params: {lang: this.$i18n.locale}});

    /*const token = localStorage.getItem('authtoken');
    return;
    if (!token) {
      return;
    }
    this.setLoginData(token);
    */
    //this.refreshJWT().catch(err => this.$router.push({name: 'login'}));

    /*if (this.user) {
      this.$ability.update(createForUser(this.CASLUser).rules);
    }*/
  }
}

export default App;
</script>

<style lang="scss">
// 1. Your custom variables and variable overwrites.
// 2. Import default variables and available mixins.
@import '../../../node_modules/uikit/src/scss/variables-theme.scss';
@import '../../../node_modules/uikit/src/scss/mixins-theme.scss';

// 3. Your custom mixin overwrites.
@mixin hook-card() {
  color: #000;
}

// 4. Import UIkit.
@import '../../../node_modules/uikit/src/scss/uikit-theme.scss';

body {
  overflow: scroll; /* Show scrollbars */
}

@import './styles/tippy.scss'
</style>
